module.exports = __webpack_public_path__ + "img/1-lg.c43af0e1.jpg";